import { render, staticRenderFns } from "./EditPatientActivity.vue?vue&type=template&id=04095086&"
import script from "./EditPatientActivity.vue?vue&type=script&lang=js&"
export * from "./EditPatientActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports